<template>
    <div>
        <div class="action-bar-body">
            <van-icon :name="collect" class="icon" size="30px" @click="onCollect"/>
            <!-- 砍掉 -->
<!--            <van-icon name="chat-o" class="icon" size="30px"/>-->
            <van-icon name="share-o" class="icon" size="30px" @click="onShare"/>
            <span class="icon ci" @click="showDescriptionPopup">词</span>
        </div>
        <!-- 歌词 -->
        <van-popup v-model:show="show" round
                   position="bottom" closeable
                   :style="{height:'40%'}"
        >
            <div class="description">{{music.description}}</div>
        </van-popup>

        <van-popup 
            v-model:show="showShare"
            style="text-align: center;
                    width: 70vw;
                    height: 20vw;
                    line-height: 20vw;
                    border-radius: 10px;
                    overflow: inherit;"
        >
            <share style="z-index: 3000"/>
        </van-popup>
    </div>
</template>

<script>
import {Share} from 'vue3-social-share';
import 'vue3-social-share/lib/index.css'
import { doCollectResource, rmCollectResource, getResource } from '@/api/CommonApi'
import { Toast } from 'vant'
import { ref } from '@vue/reactivity'
import { inject, watch } from '@vue/runtime-core'

export default {
    name: 'ActionBar',
    components: {Share},
    props:{
        music:{
            require:true,
        }
    },
    inject:[
        'resourceId', // 当前专辑ID
        'resourceItemId', // 当前专辑下资源的ID
        'enableComment', // 是否启用评论
    ],
    setup() {
        const show = ref(false)
        const showShare = ref(false)
        const isCollect = ref(false)
        const resourceId = inject('resourceId')

        watch(resourceId, (resourceId) => {
            getResource(resourceId).then(res => {
                const result = res.result
                isCollect.value = result.isUserCollect || false
            })
        })

        return {
            show,
            showShare,
            isCollect
        }
    },
    computed: {
        collect() {
            return this.isCollect ? 'star' : 'star-o'
        }
    },
    methods:{
        showDescriptionPopup(){
            this.show = true
        },
        onCollect() {
            const token = localStorage.getItem('token')
            if(token === null || token === '') {
                this.go2Login()
                return
            }

            const resourceId = this.resourceId
            if(this.isCollect) {
                rmCollectResource(resourceId).then(res => {
                    if(res.code == 200 && res.success) {
                        Toast.success('取消收藏成功！')
                        this.isCollect = false
                    } else {
                        Toast.fail(res.message)
                    }
                }).catch(err => Toast.fail(err.message))
                return
            }
            
            doCollectResource(resourceId).then(res => {
                if(res.code == 200 && res.success) {
                    Toast.success('收藏成功！')
                    this.isCollect = true
                } else {
                    Toast.fail(res.message)
                }
            }).catch(err => Toast.fail(err.message))
        },
        onShare() {
            this.showShare = true
        },
    }
}
</script>

<style scoped>
.action-bar-body{
    text-align: center;
    color: #E1DDD1;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 80vw;
    margin: 0 auto;
}

.icon {
    font-weight: 600;
}

.ci{
    font-weight: normal;
    font-size: 16px;
    width: calc(30px - 3px * 2);
    height: calc(30px - 3px * 2);
    line-height: calc(30px - 3px * 2);
    border: 3px solid #E1DDD1;
    border-radius: 50%;
}

.description{
    width: 90vw;
    margin: 10vw auto;
    white-space: break-spaces;
}
</style>
